import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Function to convert path segments to title case
const toTitleCase = (str: string) => {
  return str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Mapping for specific path segments to custom names
const pathSegmentNames: { [key: string]: string } = {
  blog: 'Blog',
  // Add more custom names as needed
};

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Don't show breadcrumbs on the homepage
  if (pathnames.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="container mx-auto px-4 sm:px-6 lg:px-8 py-3 mb-4 bg-gray-50 rounded-md">
      <ol className="flex items-center space-x-2 text-sm text-gray-500">
        <li>
          <Link to="/" className="hover:text-gray-700">Home</Link>
        </li>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const displayName = pathSegmentNames[value] || toTitleCase(value);

          return (
            <li key={to} className="flex items-center">
              <ChevronRight className="h-4 w-4 mx-1 text-gray-400" />
              {last ? (
                <span className="text-gray-700 font-medium">{displayName}</span>
              ) : (
                <Link to={to} className="hover:text-gray-700">{displayName}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
